import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { Button } from "@src/appV2/redesign/components/Button";
import { ShiftBottomSheetBookabilityCriteriaCard } from "@src/appV2/redesign/Shift/BottomSheet/BookabilityCriteriaCard";

interface BaseWorkBadgeRequiredCardProps {
  analyticsMetadata: Record<string, string | boolean | undefined>;
  onReviewPolicy: () => void;
}

export function BaseWorkBadgeRequiredCard(props: BaseWorkBadgeRequiredCardProps) {
  const { analyticsMetadata, onReviewPolicy } = props;

  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      title="Badge Required"
      description="This workplace requires you to wear a badge. Before clocking in, you'll take a photo of your badge on your work attire."
      illustrationType="complete-profile"
      footer={
        <Button
          fullWidth
          variant="outlined"
          size="medium"
          onClick={() => {
            logEvent(APP_V2_USER_EVENTS.WORK_BADGE_REVIEW_POLICY_CLICKED, analyticsMetadata);
            onReviewPolicy();
          }}
        >
          Review Policy
        </Button>
      }
    />
  );
}
